const ES = {
    title: 'Nº de celular',
    actions: 'Modificar N° de celular',
    table: {
        title: 'Nº de celular',
        columns: {
            id: 'Id',
            telephone: 'Nº de celular',
            created_at: 'Fecha alta',
            updated_at: 'Fecha modificación',
            status: 'Estado',
        },
        status: {
            3: 'Activo',
            2: 'Inactivo',
            title: 'Estado'
        },
    },
    inputs: {
        modify: 'Nuevo Número de celular',
    },
    alert: {
        info: {
            title: 'Enviamos un mensaje a ',
            description: 'El cliente tiene 24hs. para ingresar y hacer la verificación que allí se solicita'
        },
        warning: {
            title1: 'El teléfono ',
            title2: ' no está disponible para ser usado por este cliente',
            description: 'Solicite otro teléfono'
        }
    }

};

export default ES;
